import http from '@/communication/AuthConnection'

export default () => {
  return http.get('/v1/permission')
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/permission/GetPermissionList.js